var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"db-ChromeMainContent"},[_c('div',{staticClass:"db-ChromeMainContent-content",attrs:{"tabindex":"-1"}},[(_vm.currentCollectionProtocolParticipant)?_c('router-view'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }